import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgFilter({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 19a1 1 0 11-2 0v-6.415l.293-.293c1.62-1.617 3.02-3.712 4.194-6.292H5.514c1.174 2.58 2.574 4.676 4.193 6.292l.293.293V16a1 1 0 01-2 0v-2.592c-1.672-1.75-3.106-3.944-4.306-6.579A2 2 0 015.514 4h12.973a2 2 0 011.82 2.829c-1.2 2.635-2.634 4.83-4.307 6.579V19z"
        fill={color}
      />
    </svg>
  )
}

export default SvgFilter
